import React from 'react'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { cn } from '@/utils/utils'

interface Option {
    id: string
    text: string
}

interface DropdownProps {
    questionId: string
    options: Option[]
    allowOther?: boolean
    selectedOptionId?: string
}

const Dropdown: React.FC<DropdownProps> = ({
    questionId,
    options,
    allowOther = false,
    selectedOptionId,
}) => {
    return (
        <div className="mt-4 relative">
            <Select
                value={selectedOptionId || undefined}
                key={`${questionId}-preview`}
                id={`${questionId}-preview`}
                className="relative"
                disabled
            >
                <SelectTrigger
                    className="w-full !h-[52px] relative"
                    key={`${questionId}-preview-trigger`}
                    id={`${questionId}-preview-trigger`}
                >
                    <SelectValue
                        placeholder="Select an option"
                        className={cn('text-[13px] font-[450] text-[#707070]')}
                        key={`${questionId}-preview-value`}
                        id={`${questionId}-preview-value`}
                    />
                </SelectTrigger>
                <SelectContent
                    className="overflow-y-auto relative z-[151]"
                    key={`${questionId}-preview-content`}
                    id={`${questionId}-preview-content`}
                >
                    {options.map((option, index) => {
                        return (
                            <SelectItem
                                key={`${questionId}-preview-option-${option.id}`}
                                value={option.id}
                                id={`${questionId}-preview-option-${option.id}`}
                                className={cn(
                                    'text-[13px] font-[450] !h-[40px]',
                                    selectedOptionId === option.id &&
                                        'text-[#005BD3] font-[550]',
                                    option.text === '' &&
                                        'text-[#616161] italic'
                                )}
                            >
                                {option?.text !== ''
                                    ? option.text
                                    : `Response ${index + 1}`}
                            </SelectItem>
                        )
                    })}
                    {allowOther && (
                        <SelectItem
                            value="other"
                            key={`${questionId}-preview-option-other`}
                            id={`${questionId}-preview-option-other`}
                        >
                            Other
                        </SelectItem>
                    )}
                </SelectContent>
            </Select>
        </div>
    )
}

export default Dropdown
